import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const CategoryList = () => {
  const [categories, setCategories] = useState([]);
  const navigate = useNavigate();
  const [banners, setBanners] = useState([]);

  useEffect(() => {
    axios
      .get("https://api.vyapakprint.com/api/category-options")
      .then((res) => setCategories(res.data.options || res.data))
      .catch((err) => console.error(err));

    (async () => {
      try {
        const res = await fetch("https://api.vyapakprint.com/api/banner/getBanners");
        const data = await res.json();
        setBanners(
          Array.isArray(data) ? data.sort((a, b) => a.index - b.index) : []
        );
      } catch (err) {
        console.error(err);
      }
    })();
  }, []);

  const carouselSettings = {
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
  };

  return (
    <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-8">
      {/* Banner Carousel */}
      <div className="mb-12">
        <Slider {...carouselSettings}>
          {banners.length
            ? banners.map(({ _id, url }, i) => (
                <div
                  key={_id ?? i}
                  className="relative w-full h-64 sm:h-80 md:h-96 rounded-xl overflow-hidden"
                >
                  <img
                    src={url}
                    alt={`Banner ${i + 1}`}
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-black bg-opacity-20 rounded-xl"></div>
                </div>
              ))
            : [1, 2].map((n) => (
                <div
                  key={n}
                  className="flex justify-center items-center h-64 sm:h-80 md:h-96 bg-gradient-to-r from-blue-500 to-purple-600 rounded-xl text-white"
                >
                  <h2 className="text-2xl sm:text-3xl font-bold">{`Carousel Slide ${n}`}</h2>
                </div>
              ))}
        </Slider>
      </div>

      {/* Section Title */}
      <div className="text-center mb-8">
        <h1 className="text-3xl sm:text-4xl font-bold text-blue-900 mb-2">
          PRINTING SERVICES
        </h1>
        <div className="w-24 h-1 bg-blue-600 mx-auto rounded-full"></div>
      </div>

      {/* Category Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-6">
        {categories.map((cat) => (
          <div
            key={cat._id}
            onClick={() => navigate(`/products/${cat._id}`)}
            className="group cursor-pointer bg-white rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 overflow-hidden border border-gray-100"
          >
            {/* Image Container */}
            <div className="relative w-full h-48 sm:h-52 md:h-48 lg:h-52 overflow-hidden">
              <img
                src={cat.image}
                alt={cat.name}
                className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
            </div>

            {/* Content */}
            <div className="p-4">
              <h3 className="text-center text-sm sm:text-base font-semibold text-gray-800 group-hover:text-blue-600 transition-colors duration-300 line-clamp-2">
                {cat.name}
              </h3>
            </div>
          </div>
        ))}
      </div>

      {/* Empty State */}
      {categories.length === 0 && (
        <div className="text-center py-12">
          <div className="text-gray-400 text-xl mb-4">📄</div>
          <h3 className="text-lg font-medium text-gray-600 mb-2">
            No Services Available
          </h3>
          <p className="text-gray-500">
            Please check back later for printing services.
          </p>
        </div>
      )}
    </div>
  );
};

export default CategoryList;
